export default __webpack_public_path__ + "static/media/dealership2.04971dda.png";